// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line no-unused-vars
import { Field } from 'react-final-form';
// eslint-disable-next-line no-unused-vars
import { FxPasswordGenerator } from 'axp-fx-common';
import { updatePasswordFormFields } from './UpdatePasswordFormInitData';
import actionType from '../../../constants/actionType';

const UpdatePasswordChildForm = ({ form, action }) => {
  const [showPasswordGenerator, setPasswordGenerator] = useState(false);

  const handleAdditionalTextClick = () => setPasswordGenerator(!showPasswordGenerator);

  const handlePasswordFillButtonClick = (password) => {
    form.change('password', password);
    form.change('confirmPassword', password);
    setPasswordGenerator(!showPasswordGenerator);
  };

  return (
    <div className="flex margin-2-b">
      <div className="col-md-3 position-relative pad-0-l">
        <Field
          {...updatePasswordFormFields.password}
          onAdditionalTextClick={handleAdditionalTextClick}
          label={
            action === actionType.ACTIVATE_FX_ACCOUNT.name
              ? 'Password'
              : 'New Password'
          }
        />
        {showPasswordGenerator && (
          <FxPasswordGenerator
            onPasswordModalClose={handleAdditionalTextClick}
            onPasswordFillButtonClick={handlePasswordFillButtonClick}
          />
        )}
      </div>
      <Field {...updatePasswordFormFields.confirmPassword} />
    </div>
  );
};

UpdatePasswordChildForm.propTypes = {
  form: PropTypes.shape.isRequired,
  action: PropTypes.string.isRequired,
};

UpdatePasswordChildForm.displayName = 'UpdatePasswordChildForm';

export default UpdatePasswordChildForm;
